import { useTranslation } from "react-i18next";
import { chipText, optionFields } from "../data/getting-started";

export const OptionCard = ({ option, optionObj = {} }) => {
  const { t, i18n } = useTranslation("coaching-portal");
  const isFilled = !!optionObj[optionFields[option]];
  const hasChip = option in chipText;
  const chipTextKey = hasChip
    ? `customWorkflows.${isFilled ? "chipTextFilled" : "chipText"}.${option}`
    : null;
  const buttonTextKey = `customWorkflows.${isFilled ? "btnTextFilled" : "btnText"}.${option}`;
  const hasLabel = i18n.exists(buttonTextKey, { ns: "coaching-portal" });
  const buttonLabel = t(buttonTextKey);

  return (
    <article>
      <div>
        <p className="s2">{t(`customWorkflows.optionName.${option}`)}</p>
        <p className="p5 mt-2">
          {t(`customWorkflows.optionDescription.${option}`)}
        </p>
        {chipTextKey && (
          <div className={`chip ${isFilled ? "info check" : "warning"} mt-4`}>
            {t(chipTextKey)}
          </div>
        )}
      </div>
      {hasLabel && (
        <div>
          <a
            href={`/actions/refresh?modal[type]=${option}`}
            data-button-type="outline"
            role="button"
          >
            <span>{buttonLabel}</span>
          </a>
        </div>
      )}
    </article>
  );
};
